<script setup lang="ts">
/** Export the pack: CSV, JSON and print, each committing the working edits as a revision first. */
import { computed } from 'vue';
import Icon from './Icon.vue';
import AppDialog from './AppDialog.vue';
import { snap, ui } from '@/app/state';
import { announce } from '@/app/announce';
import { exportBlocker, nextRevId } from '@/app/navigation';
import { exportPack, type ExportKindUi } from '@/app/exports';

const block = computed(() => { void snap.value; return exportBlocker(); });
const lede = computed(() => {
  const s = snap.value;
  if (block.value) return `${block.value} CSV and print are off until then; JSON is kept for debugging and says validation.ok is false.`;
  return s.isDirty || !s.currentRevision ? `Exporting saves your edits as ${nextRevId()} first, so every pack names one frozen revision and its hash.` : `Exports name ${s.currentRevisionId} as it is.`;
});
function go(e: MouseEvent, kind: ExportKindUi) {
  if ((e.currentTarget as HTMLElement).getAttribute('aria-disabled') === 'true') { announce(`Not available: ${block.value}`); return; }
  ui.exportSheetOpen = false;
  void exportPack(kind);
}
</script>

<template>
  <AppDialog :open="ui.exportSheetOpen" labelledby="exportTitle" @close="ui.exportSheetOpen = false">
    <div class="dlg-head">
      <h2 id="exportTitle" class="h-display">Export the pack</h2>
      <button type="button" class="icon-btn" data-close aria-label="Close" @click="ui.exportSheetOpen = false"><Icon name="close" /></button>
    </div>
    <p class="dlg-lede">{{ lede }}</p>
    <div class="dlg-acts dlg-acts--stack">
      <button type="button" class="btn btn--quiet" data-act="csv" :aria-disabled="block ? 'true' : undefined" @click="go($event, 'csv')"><Icon name="download" /> Cut list CSV</button>
      <button type="button" class="btn btn--quiet" data-act="json" @click="go($event, 'json')"><Icon name="download" /> Project JSON</button>
      <button type="button" class="btn btn--ink" data-act="print" :aria-disabled="block ? 'true' : undefined" @click="go($event, 'print')"><Icon name="print" /> Print / Save as PDF</button>
    </div>
  </AppDialog>
</template>
